import React, { FC } from 'react';

import './styles.scss';

interface IProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const Modal: FC<IProps> = ({ open, onClose, children, title }) => {
  return (
    open && (
      <div className="Modal">
        <div className="Modal-overlay" />
        <div className="Modal-content">
          <p className="Modal-contentTitle">{title}</p>
          <p className="Modal-contentChildren">{children}</p>
          <button className="Modal-contentButton" onClick={onClose}>
            Close Window
          </button>
        </div>
      </div>
    )
  );
};

export default Modal;
